// Models
import { BaseModel } from '../../../woopa-ui/api';
import { Review } from './';
import { Placement } from './';

/**
 * Represents a position in the app.
 */
export interface Position extends BaseModel {
  location: string;
  sector: string;
  objectTypeId: number;
  identifier: string;
  // Optional attributes
  active?: boolean;
  status?: number;
  lastReview?: Review;
  currentPlacement?: Placement;
  placements?: Placement[];
  qrUrl?: string;
  attributeValuesAttributes?: any[];
  attributeValues?: any[];
}

/**
 * List of position status.
 */
export const POSITION_STATUSES = [
  'Correcto',
  'Advertencia',
  'Falla',
  'Pendiente',
  'Nuevo'
];

/**
 * List of position extras.
 */
export const POSITION_EXTRAS = {
  normalPosition: 'Posición normal'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/position.interface.ts